import type { NotifyObservationTransitionProps } from "./observation-action-transition.type";

import { Trans } from "react-i18next";

import { ONE_MINUTE_IN_SECONDS } from "@/constants/Time";
import { BatchPreviewTransitionLink } from "@/modules/batch-preview/batch-preview-transition-link";
import { ModelLink } from "@/modules/model-link";
import { OrganizationContextLabel } from "@/modules/organization/organization-context-label";
import { StateTag } from "@/modules/state-tag";
import { UserAvatar } from "@/ui/user-avatar";

export const notifyObservationTransition = ({
  notify,
  payload,
}: NotifyObservationTransitionProps) => {
  const { context, event_type, user, state, observations } = payload;
  const count = observations.length;
  const ids = observations.map(({ id }) => id);

  const onLinkClick = () => {
    notify.close(payload.id);
  };

  notify.info({
    key: payload.id,
    title: (
      <Trans
        i18nKey="notification:observationTransition.description"
        values={{
          userName: user.name,
          observationName: observations[0]?.name ?? "",
          count,
        }}
        components={{
          StateTag: <StateTag value={state} type="observation" asText />,
        }}
      />
    ),
    icon: (
      <UserAvatar
        size="small"
        statusColor="info"
        user={{ name: user.name }}
        withTooltip
      />
    ),
    actions: (
      <>
        {count === 1 ? (
          <ModelLink
            model="observation"
            item={observations[0]}
            showIcon
            modelAsName
            customContext={context}
            onClick={onLinkClick}
          />
        ) : (
          <BatchPreviewTransitionLink
            type={event_type}
            state={state}
            userId={user.id}
            ids={ids}
            customContext={context}
            onClick={onLinkClick}
            icon="model"
          />
        )}
        <OrganizationContextLabel context={context} isSmall />
      </>
    ),
    duration: ONE_MINUTE_IN_SECONDS,
  });
};
